module.exports = __webpack_public_path__ + "static/media/aquarium-scenes.6847afe7.mov";